"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var Icon = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.focusable, focusable = _c === void 0 ? false : _c, children = _a.children, _d = _a.size, size = _d === void 0 ? 'md' : _d, rest = tslib_1.__rest(_a, ["focusable", "children", "size"]);
    var sizesMap = {
        lg: 32,
        md: 24,
        sm: 16
    };
    return ((0, jsx_runtime_1.jsx)("svg", tslib_1.__assign({ ref: ref, width: (_b = sizesMap[size]) !== null && _b !== void 0 ? _b : size, viewBox: '0 0 192 192', focusable: focusable, fill: 'currentColor' }, rest, { children: children })));
});
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = Icon;
